import Bugsnag from '@bugsnag/js';

// based on https://gist.github.com/MIchaelMainer/ef5202f5566987636eda && https://en.wikipedia.org/wiki/Magic_number_(programming)#In_files
export default function getFileMimeType(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onerror = (e) => reject(e);

    reader.onloadend = (e) => {
      if (!e || !e.target) {
        return reject('Could not load file');
      }

      const arr = new Uint8Array(e.target.result as ArrayBufferLike);
      const len = arr.length;
      let header = '';

      for (let i = 0; i < len; i++) {
        header += arr[i].toString(16);
      }

      switch (header) {
        case '89504e47': {
          return resolve('image/png');
        }
        case '47494638': {
          return resolve('image/gif');
        }
        case 'ffd8ffe0':
        case 'ffd8ffe1':
        case 'ffd8ffe2': {
          return resolve('image/jpeg');
        }
        case '25504446': {
          return resolve('image/pdf');
        }
        case '3c737667':
        case '3c3f786d': {
          return resolve('image/svg+xml');
        }
        case 'd0cf11e0': {
          return resolve('application/vnd.ms-powerpoint');
        }
        case '504b34': {
          return resolve(
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
          );
        }
        case '1a45dfa3': {
          return resolve('video/webm');
        }
        default: {
          Bugsnag.notify(`Unknown file type: ${header}`);
          return resolve('unknown');
        }
      }
    };

    reader.readAsArrayBuffer(file.slice(0, 4));
  });
}
